import useRequest from '@/websdk/utils/request';

export default (function (params) {
  const { exec, isRequestSuccessed } = useRequest({
    url: '/api/device/import-config',
    name: 'PUT_DEV_CONFIG',
    method: 'PUT',
  });

  return [exec, isRequestSuccessed];
});
